import { rootUrl } from '../const';
import { productExcelDownload } from './downloadProductExcel';

export const ProductAPI = {
	productExcelDownload: productExcelDownload(rootUrl),
};
